
export enum BackendErrorCode {
  NotValidEmail= 'NotValidEmail',
  WeakPassword= 'WeakPassword',
  InvalidEnumValue= 'InvalidEnumValue',
  InvalidUUID= 'InvalidUUID',
  InvalidJWT= 'InvalidJWT',
  InvalidDate= 'InvalidDate',
  InvalidBoolean= 'InvalidBoolean',
  InvalidLength= 'InvalidLength',
  IsNotTrue= 'IsNotTrue',
  NotAString= 'NotAString',
  EmptyString= 'EmptyString',
  InvalidPhoneNumber= 'InvalidPhoneNumber',
  NumberTooSmallThanRelated= 'NumberTooSmallThanRelated',
  NumberTooBigThanRelated= 'NumberTooBigThanRelated',
  NotAWorkingDay= 'NotAWorkingDay',
  PropertyShouldNotExists= 'PropertyShouldNotExists',
  InvalidBidAmount= 'InvalidBidAmount',
  InvalidPropertyByRules= 'InvalidPropertyByRules',
  InvalidBusDossierImageName= 'InvalidBusDossierImageName',
  InvalidBusDossierDamageImageName= 'InvalidBusDossierDamageImageName',
  InvalidBusAssetVideoName= 'InvalidBusAssetVideoName',
  AssetCoverImageMissing= 'AssetCoverImageMissing',
  AssetMissingAtLeastOneImage= 'AssetMissingAtLeastOneImage',
  EmailAlreadyInUse= 'EmailAlreadyInUse',
  InvalidAuctionState= 'InvalidAuctionState',
  BFAAlreadyExistsForVersion= 'BFAAlreadyExistsForVersion',
  VersionNameAlreadyExistsForModel= 'VersionNameAlreadyExistsForModel',
  InvalidParameters= 'InvalidParameters',
  SalesRepMustHavePhoneNumber= 'SalesRepMustHavePhoneNumber',
  OTPCodeNotValid= 'OTPCodeNotValid',
  TinMustBeFilled= 'TinMustBeFilled',
  PrismaError= 'PrismaError',
  EntityNotFound= 'EntityNotFound',
  EntityAlreadyExists= 'EntityAlreadyExists',
  PasswordResetEmailNotExists= 'PasswordResetEmailNotExists',
  SignupUserAlreadyExists= 'SignupUserAlreadyExists',
  SignupCompanyWithSamePecAlreadyExists= 'SignupCompanyWithSamePecAlreadyExists',
  OnboardingAlreadyCompleted= 'OnboardingAlreadyCompleted',
  UserAlreadyAssociatedToACompany= 'UserAlreadyAssociatedToACompany',
  UserHasNotOnboardingSessionCompanyId= 'UserHasNotOnboardingSessionCompanyId',
  EmailChangeWrongPassword= 'EmailChangeWrongPassword',
  AuthAuthenticationVersionMismatch= 'AuthAuthenticationVersionMismatch',
  AuthNoAdminByEmail= 'AuthNoAdminByEmail',
  AuthNoUserByEmail= 'AuthNoUserByEmail',
  AuthTokenExpired= 'AuthTokenExpired',
  AuthTokenNotSubmitted= 'AuthTokenNotSubmitted',
  AuthTokenNotValid= 'AuthTokenNotValid',
  AuthWrongPassword= 'AuthWrongPassword',
  AuthPasswordNotSet= 'AuthPasswordNotSet',
  PasswordDoNotMatch= 'PasswordDoNotMatch',
  ActionRequiresCompany= 'ActionRequiresCompany',
  AuthEmailNotVerified= 'AuthEmailNotVerified',
  AuthNotEnoughPermission= 'AuthNotEnoughPermission',
  ForbiddenRequest= 'ForbiddenRequest',
  UserIsBanned= 'UserIsBanned',
  BailNotAuthorized= 'BailNotAuthorized',
  BailCantVoid= 'BailCantVoid',
  GenericError= 'GenericError',
  UserHasNoCompany= 'UserHasNoCompany',
  AdminUserProfileImageNotFound= 'AdminUserProfileImageNotFound',
  UploadFileError= 'UploadFileError',
  InvalidCaptcha= 'InvalidCaptcha',
  MissingCaptcha= 'MissingCaptcha',
  AuctionExpired= 'AuctionExpired',
  AuctionNotRunning= 'AuctionNotRunning',
  AuctionClearingPriceNotSettable= 'AuctionClearingPriceNotSettable',
  AuctionInitialExpiresAtInvalid= 'AuctionInitialExpiresAtInvalid',
  AuctionInvalidMainAssetId= 'AuctionInvalidMainAssetId',
  AuctionUpdateDenied= 'AuctionUpdateDenied',
  AuctionStartingPriceInvalid= 'AuctionStartingPriceInvalid',
  AuctionSellerReservePriceInvalid= 'AuctionSellerReservePriceInvalid',
  AuctionBidStepInvalid= 'AuctionBidStepInvalid',
  MainAssetWithoutBusAsset= 'MainAssetWithoutBusAsset',
  AuctionNoBusAsset= 'AuctionNoBusAsset',
  InvalidDirectSaleState= 'InvalidDirectSaleState',
  RequirementsNotMeetToChangeState= 'RequirementsNotMeetToChangeState',
  DirectSaleUpdateDenied= 'DirectSaleUpdateDenied',
  CantBuyDirectSaleNotOpen= 'CantBuyDirectSaleNotOpen',
  CantBuyDirectSaleOrderNotPaid= 'CantBuyDirectSaleOrderNotPaid',
  CantBuyDirectSaleHasDirectSaleOrder= 'CantBuyDirectSaleHasDirectSaleOrder',
  CantBuyPendingBail= 'CantBuyPendingBail',
  UserHasMoreThanOneActiveDirectSaleOrder= 'UserHasMoreThanOneActiveDirectSaleOrder',
  InvalidUserForOrderDetail= 'InvalidUserForOrderDetail',
  CantPerformUserCompanyEqSellerCompany= 'CantPerformUserCompanyEqSellerCompany',
  CantPerformScrapSaleNotScrapyardCompany= 'CantPerformScrapSaleNotScrapyardCompany',
  CantPerformCompanyNotYetApprovedForScrap= 'CantPerformCompanyNotYetApprovedForScrap',
  CantPerformCompanyNotApprovedForScrap= 'CantPerformCompanyNotApprovedForScrap',
  CantPerformCompanyUnderReview= 'CantPerformCompanyUnderReview',
  CantPerformUnapprovedCompany= 'CantPerformUnapprovedCompany',
  CantPerformBannedCompany= 'CantPerformBannedCompany',
  CantPerformRegisteredCompany= 'CantPerformRegisteredCompany',
  CantPerformUserWithoutCompany= 'CantPerformUserWithoutCompany',
  CantPerformUserNoBail= 'CantPerformUserNoBail',
  CantPerformPurchase= 'CantPerformPurchase',
  SaleAssetCongruenceMismatch= 'SaleAssetCongruenceMismatch',
  AssetAlreadyForSale= 'AssetAlreadyForSale',
  AssetNotFound= 'AssetNotFound',
  InvalidUrlKeyValue= 'InvalidUrlKeyValue',
  CantBidAuctionIsNotRunning= 'CantBidAuctionIsNotRunning',
  CantBidUserWithAutoBidActive= 'CantBidUserWithAutoBidActive',
  BidScenarioNotSupported= 'BidScenarioNotSupported',
  BidScenarioNotConfigured= 'BidScenarioNotConfigured',
  CantBidUnhandledScenario= 'CantBidUnhandledScenario',
  InvalidAutoBidAmount= 'InvalidAutoBidAmount',
  InvalidAutoBidId= 'InvalidAutoBidId',
  CantAutoBid= 'CantAutoBid',
  BidNotCreated= 'BidNotCreated',
  InvalidUserAutoBid= 'InvalidUserAutoBid',
  InvalidAuctionAutoBid= 'InvalidAuctionAutoBid',
  UnexpectedAutoBidData= 'UnexpectedAutoBidData',
  PaymentProviderError= 'PaymentProviderError',
  WinningBidNotFound= 'WinningBidNotFound',
  CountryCodeNotFound= 'CountryCodeNotFound',
  VatNumberNotFound= 'VatNumberNotFound',
  NegotiationBuyerProposalNotValid= 'NegotiationBuyerProposalNotValid',
  NegotiationSellerProposalNotValid= 'NegotiationSellerProposalNotValid',
  NegotiationNotOpen= 'NegotiationNotOpen',
  NegotiationStateInvalid= 'NegotiationStateInvalid',
  NegotiationInvalidParticipant= 'NegotiationInvalidParticipant',
  NegotiationProposalNotFound= 'NegotiationProposalNotFound',
  NegotiationNextParticipantNotFound= 'NegotiationNextParticipantNotFound',
  NegotiationAuctionIsRelistsAncestor= 'NegotiationAuctionIsRelistsAncestor',
  DirectSaleNegotiationRequestNotValid= 'DirectSaleNegotiationRequestNotValid',
  RelatedParamsInvalid= 'RelatedParamsInvalid',
  CompanyInfoNotFound= 'CompanyInfoNotFound',
  CompanyMainMemberCannotBeApproved= 'CompanyMainMemberCannotBeApproved',
  MainMemberAlreadyPresent= 'MainMemberAlreadyPresent',
  LogisticsServiceDestinationCountryNotSupported= 'LogisticsServiceDestinationCountryNotSupported',
  ValueAddedServiceNotFound= 'ValueAddedServiceNotFound',
  ValueAddedServiceNotSupported= 'ValueAddedServiceNotSupported',
  InvoiceNotFound= 'InvoiceNotFound',
  TaxCodeAlreadyExists= 'TaxCodeAlreadyExists',
  InvalidTaxCodeOriginCombination= 'InvalidTaxCodeOriginCombination',
  BusAssetMissingLicensePlace= 'BusAssetMissingLicensePlace',
  MultipleWhatsappEnabledNumbersForAdmin= 'MultipleWhatsappEnabledNumbersForAdmin',
  DepotTermsNotAccepted= 'DepotTermsNotAccepted',
  DepotServiceModificationDenied= 'DepotServiceModificationDenied',
  PublicationApprovalNotFound= 'PublicationApprovalNotFound',
  PublicationApprovalAlreadyApproved= 'PublicationApprovalAlreadyApproved',

}